import apiUser from './apiUser';
import apiStaff from './apiStaff';
import { Setting, Request } from '../';
import { sleep } from '@yichui/js-contrib/src/utils';
import auth from './auth';

//
let doing_detail = false; // 防并发请求
let doing_check = false; // 防并发请求
let doing_code = ''; // 暂存的小程序登录code

//
const state = {
  // userInfo: null,
  //
  isAuth: false, // true: 用户有token且验证有效
  isStaff: false, // true: 是管理员
  isInit: false, // true: 已经获取过detail信息
  isLoginAuto: true, // true:小程序自动登录
  token: {}, // token对象
  detailUser: {}, // 用户信息
  detailStaff: {}, // 管理员信息
};

//
const mutations = {
  SET_AUTH: (state, isAuth) => {
    state.isAuth = !!isAuth;
  },
  SET_STAFF: (state, isStaff) => {
    state.isStaff = !!isStaff;
  },
  SET_INIT: (state, isInit) => {
    state.isInit = !!isInit;
  },
  SET_LOGIN_AUTO: (state, isLoginAuto) => {
    state.isLoginAuto = !!isLoginAuto;
  },
  SET_TOKEN: (state, token) => {
    state.token = Object.assign({}, token);
  },
  SET_DETAIL_USER: (state, detailUser) => {
    state.detailUser = Object.assign({}, detailUser);
  },
  SET_DETAIL_STAFF: (state, detailStaff) => {
    state.detailStaff = Object.assign({}, detailStaff);
  },
  //
  updateState(state, payload) {
    const keys = Object.keys(payload);
    keys.forEach(key => {
      state[key] = payload[key];
    });
  },
};

//
const actions = {
  // 设置用户模块逻辑配置 如禁止小程序自动登录: dispatch('user/setting', { isLoginAuto:false })
  async setting({ commit }, params) {
    const { isLoginAuto } = params;
    if (isLoginAuto === true || isLoginAuto === false) {
      commit('SET_LOGIN_AUTO', !!isLoginAuto);
    }
  },
  // [管理员/用户] 清理token
  async clean({ commit }) {
    // 删除回调
    Request.delValue(Setting.getStoreUrl());
    // 删除token值
    Request.delToken();
    // 删除uid
    Request.delUid();
    // 删除staff
    Request.delStaff();
    // 删除token对象
    commit('SET_TOKEN', {});
    // 标记未登录
    commit('SET_AUTH', false);
    // 标记未知
    commit('SET_STAFF', false);
    // 标记未初始化
    commit('SET_INIT', false);
  },
  // [管理员/用户] 登出
  async logout({ state, dispatch }, params) {
    const isStaff = Request.getStaff();
    const api = isStaff ? apiStaff.logoutStaff : apiUser.logoutUser;
    let ret = false;
    if (state.isAuth) {
      await api();
      console.log(`[debug-async] api`);
      await dispatch('clean');
      console.log(`[debug-async] clean`);
      ret = true;
    }
    return ret;
  },
  // [管理员/用户] 刷新已有token
  async statusCheck({ commit, state, dispatch }, params) {
    if (!Request.getToken()) {
      // 没有token,不执行任何逻辑
      return null;
    }
    const isStaff = Request.getStaff();
    const api = isStaff ? apiStaff.statusStaff : apiUser.statusUser;
    // 放并发处理
    if (doing_check) {
      while (doing_check) {
        await sleep(50);
        console.log(`[debug-async] sleep`);
      }
    }
    // 更新token
    let isSuccess = true; // true:更新成功
    try {
      doing_check = true;
      // 先检查session
      const retCheck = await auth.checkWxSession();
      console.log(`[debug-async] checkWxSession`);
      if (!retCheck) {
        isSuccess = false;
      }
      // 刷新token
      if (isSuccess) {
        const data = await api(params);
        console.log(`[debug-async] api`);
        if (!data) {
          isSuccess = false;
        } else {
          // token更新成功
          console.log('[token-fresh]', data);
          // 储存token值
          Request.setToken(data.token);
          // 储存uid
          Request.setUid(data.uid);
          // 储存staff
          Request.setStaff(isStaff);
          // 储存token对象
          commit('SET_TOKEN', data);
          // 标记已登录
          commit('SET_AUTH', true);
          // 标记是管理员
          commit('SET_STAFF', isStaff);
          // 标记已登录
          commit('SET_AUTH', true);
          // 自动初始化
          if (!state.isInit && !doing_detail) {
            await dispatch('detail');
            console.log(`[debug-async] detail`);
          }
        }
      }
    } catch (err) {
      console.log('[status-check-err]', err);
      isSuccess = false;
    }
    // 但凡出错,清空状态
    if (!isSuccess) {
      await dispatch('clean');
      console.log(`[debug-async] clean`);
    }
    doing_check = false;
    //
    return state.token && state.token.uid ? state.token : null;
  },
  // [用户] 小程序自动登录/注册 只返回token
  async loginAuto({ state, commit, dispatch }, params) {
    console.log('[debug] loginAuto-getAuthSync begin');
    const data = await auth.getAuthSync();
    console.log('[debug] loginAuto-getAuthSync done');
    if (data) {
      // 储存token值
      Request.setToken(data.token);
      // 储存uid
      Request.setUid(data.uid);
      // 储存staff
      Request.setStaff(false);
      // 储存token对象
      commit('SET_TOKEN', data);
      // 标记是用户
      commit('SET_STAFF', false);
      // 标记已登录
      commit('SET_AUTH', true);
      // 初始化
      if (!state.isInit && !doing_detail) {
        await dispatch('detail');
        console.log(`[debug-async] detail`);
      }
    }
    console.log('[debug] loginAuto finish');
    return data;
  },
  // 取微信登录code
  async wxLoginCode({ state, commit, dispatch }, params) {
    doing_code = await auth.getWxMiniAppCode();
    console.log(`[debug-async] getWxMiniAppCode`);
    return doing_code;
  },
  // [管理员/用户] 手机号登录
  async loginByPhone({ state, commit, dispatch }, params) {
    const isStaff = Request.getStaff();
    if (params === 'login') {
      // 小程序登录
      doing_code = await auth.getWxMiniAppCode();
      console.log(`[debug-async] getWxMiniAppCode`);
    } else {
      // 获取小程序手机号
      // console.log('[loginByPhone]', params);
      if (params && params.detail && params.detail.errMsg === 'getPhoneNumber:ok') {
        // 用户同意
        // console.log('小程序登录码', doing_code);
        // console.log('手机号解码1', params.detail.encryptedData);
        // console.log('手机号解码2', params.detail.iv);
        // 登录
        const data = await auth.getAuthByPhone(doing_code, params.detail.encryptedData, params.detail.iv);
        console.log(`[debug-async] getAuthByPhone`);
        if (data) {
          // console.log('登录成功', data);
          // 储存token值
          Request.setToken(data.token);
          // 储存uid
          Request.setUid(data.uid);
          // 储存staff
          Request.setStaff(isStaff);
          // 储存token对象
          commit('SET_TOKEN', data);
          // 标记是用户
          commit('SET_STAFF', false);
          // 标记已登录
          commit('SET_AUTH', true);
          // 初始化
          if (!state.isInit && !doing_detail) {
            const detail = await dispatch('detail');
            console.log(`[debug-async] detail`);
            if (detail && detail.user) {
              data.$user = detail.user;
            }
          }
        }
        data.$code = doing_code; // 将code回传
        data.$event = params; // 将event回传
        return data;
      } else {
        // 用户拒绝
        console.log('用户拒绝', params);
      }
    }
    return null;
  },
  // [管理员/用户] 详情资料
  async detail({ commit, state, dispatch }, params) {
    const isStaff = Request.getStaff();
    const api = isStaff ? apiStaff.detailStaff : apiUser.detailUser;
    // 防并发,然后返回缓存
    if (doing_detail) {
      // 等待结果
      let t = 0;
      while (doing_detail) {
        const r0 = await sleep(50); // 延时10毫秒继续尝试
        console.log(`[debug-async] sleep`, r0);
        t += 1;
        if (t >= 100) {
          // 5秒超时
          doing_detail = false;
          console.log('[doing_detail] timeout');
          return null;
        }
      }
    } else {
      // 发起网络请求获取数据
      try {
        doing_detail = true;
        // 确保token存在
        let tryLogin = false;
        if (!Request.getToken()) {
          // token没有:尝试自动登录
          tryLogin = state.isLoginAuto;
        } else if (!(state.token && state.token.uid)) {
          // token存在:验证有效性
          const r0 = await dispatch('statusCheck');
          console.log(`[debug-async] statusCheck`, r0);
          if (!r0) {
            // token无效
            if (!state.isLoginAuto) {
              // 不允许自动登录
              console.log(`[auto-login-disable]`);
              return null;
            } else {
              // 自动登录
              tryLogin = true;
            }
          }
        }
        if (tryLogin) {
          // 尝试自动登录获取新token
          const r0 = await dispatch('loginAuto');
          console.log(`[debug-async] loginAuto`, r0);
          if (!Request.getToken()) {
            // 还是没有token
            doing_detail = false;
            return null;
          }
        }
        // 请求业务接口
        const data = await api(params);
        console.log(`[debug-async] api`, data);
        if (!data) {
          // 请求出错
          doing_detail = false;
          return null;
        }
        if (isStaff) {
          commit('SET_DETAIL_STAFF', data);
          commit('SET_DETAIL_USER', Object.assign({}, data.user));
        } else {
          commit('SET_DETAIL_USER', data);
          // 存openId
          if (data && data.weixin && data.weixin.base) {
            Request.setOpenId(data.weixin.base.openId);
          }
        }
        const doInit = !state.isInit; // 只执行一次
        // 标记已初始化
        commit('SET_INIT', true);
        // 标记已登录
        commit('SET_AUTH', true);
        // 模块初始化
        if (doInit) {
          Setting.doInitialHandlerToken(state.token);
        }
      } catch (err) {
        // 未知错误
        console.warn('[detail-err]', err);
        // 标记已初始化
        commit('SET_INIT', false);
        // 标记已登录
        commit('SET_AUTH', false);
        //
        doing_detail = false;
        return null;
      }
      doing_detail = false;
    }
    //
    if (isStaff) {
      return {
        user: state.detailUser,
        staff: state.detailStaff,
      };
    } else {
      return {
        user: state.detailUser,
      };
    }
  },
  //
  // async userDetail({ commit }) {
  //   const data = await apiUser.getUserDetail();
  //   const {
  //     profile: { phone, icon, name, wxIcon, wxNickname },
  //     weixin,
  //   } = data;
  //   commit('updateState', {
  //     userInfo: {
  //       phone,
  //       icon,
  //       wxIcon,
  //       name,
  //       wxNickname,
  //       weixin,
  //     },
  //   });
  // },
  // 更新用户第三方资料
  async updateBindProfile({ commit, dispatch }, params) {
    const res = await apiUser.updateBindProfile(params);
    console.log(`[debug-async] updateBindProfile`);
    await dispatch('detail');
    console.log(`[debug-async] detail`);
    return res;
  },
};

//
const getters = {
  // 解析token中的平台和设备信息
  authAgent: state => {
    let ret = '';
    if (state.token && state.token.id) {
      const attr = state.token.id.split('|');
      if (attr.length > 1) {
        ret = attr[0];
      }
    }
    return ret;
  },
  authDev: state => {
    let ret = '';
    if (state.token && state.token.id) {
      const attr = state.token.id.split('|');
      if (attr.length > 1) {
        ret = attr[1];
      }
    }
    return ret;
  },
  // 用户头像
  avatar: state => {
    let path = '';
    let ret = '';
    // 用户自定义头像
    if (!path && state.detailUser && state.detailUser.profile) {
      path = state.detailUser.profile.icon;
    }
    // 用户绑定微信头像
    if (!path && state.detailUser && state.detailUser.weixin && state.detailUser.weixin.base) {
      path = state.detailUser.weixin.base.icon;
    }
    // 用户企业微信头像
    // 服务器头像
    if (path && !ret) {
      ret = `${Setting.getImgPath()}${path}`;
    }
    // 默认头像定义
    if (!path && !ret) {
      return Setting.defaultAvatar;
    }
    return ret;
  },
  // 用户小头像
  avatarMini: state => {
    let path = '';
    let ret = '';
    // 用户自定义头像
    if (!path && state.detailUser && state.detailUser.profile) {
      path = state.detailUser.profile.icon;
    }
    // 用户绑定微信头像
    if (!path && state.detailUser && state.detailUser.weixin && state.detailUser.weixin.base) {
      path = state.detailUser.weixin.base.icon;
    }
    // 用户企业微信头像
    // 服务器头像
    if (path && !ret) {
      ret = `${Setting.getImgThumbPath()}${path}`;
    }
    // 默认头像定义
    if (!path && !ret) {
      return Setting.defaultAvatar;
    }
    return ret;
  },
  // 用户昵称
  nickname: state => {
    let ret = '';
    if (state.isStaff) {
      // 管理员昵称获取
      if (state.detailStaff && state.detailStaff.adminName) {
        ret = state.detailStaff.adminName;
      }
    } else {
      // 用户昵称
      if (state.detailUser && state.detailUser.nickname) {
        ret = state.detailUser.nickname;
      }
    }
    return ret;
  },
  // 用户角色
  roles: state => {
    const ret = [];
    if (state.detailUser && state.detailUser.auth) {
      state.detailUser.auth.roles.forEach(v => {
        ret.push(v.key);
      });
    }
    return ret;
  },
  // 用户权限
  perms: state => {
    const ret = [];
    if (state.detailUser && state.detailUser.auth) {
      state.detailUser.auth.perms.forEach(v => {
        ret.push(v.key);
      });
    }
    return ret;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
